module.exports = __webpack_public_path__ + "img/h2.4230fb0c.png";